<template>
  <apexchart
    width="250"
    type="bar"
    :options="chartOptions"
    :series="series"
  />
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  props: {
    data: {
      type: [Object, String, Array],
      default() {
        return {}
      },
      required: false,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          id: 'vuechart-example',
          type: 'histogram',
          toolbar: {
            show: false,
          },
        },
        selection: {
          enabled: true,
        },
        dataLabels: { enabled: false },
        xaxis: {
          labels: { show: false },

          axisTicks: {
            show: false,
          },
          categories: [],
        },
        tooltip: {
          enabled: false,
        },
        yaxis: {
          show: false,
          labels: { show: false },

          axisTicks: {
            show: false,
          },
        },
      },
      series: [{
        data: [],
      }],
    }
  },
  mounted() {
    this.chartOptions.xaxis.categories = this.data.histogram_x
    this.series[0].data = this.data.histogram_y
    console.log('series', this.data)
  },
}
</script>
